"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ShippingCharge = exports.PaymentRemain = exports.OrderStatus = exports.OrderByTrans = exports.OrderBy = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _customer = require("@/api/customer");
var _customerGroup = require("@/api/customer-group");
var _customerSource = require("@/api/customer-source");
var _product = require("@/api/product");
var _staff = require("@/api/staff");
var _vuePropertyDecorator = require("vue-property-decorator");
var _paymentType = require("@/types/paymentType");
var _order = require("@/types/order");
var FilterOrder = /*#__PURE__*/function (_Vue) {
  function FilterOrder() {
    var _this;
    (0, _classCallCheck2.default)(this, FilterOrder);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, FilterOrder, [].concat(args));
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "staffs", []);
    (0, _defineProperty2.default)(_this, "customers", []);
    (0, _defineProperty2.default)(_this, "saleChannels", []);
    (0, _defineProperty2.default)(_this, "customerGroups", []);
    (0, _defineProperty2.default)(_this, "products", []);
    (0, _defineProperty2.default)(_this, "OrderStatus", OrderStatus);
    (0, _defineProperty2.default)(_this, "PaymentStatus", _paymentType.PaymentStatus);
    (0, _defineProperty2.default)(_this, "DeliveryFeeTypeTrans", _order.DeliveryFeeTypeTrans);
    (0, _defineProperty2.default)(_this, "PaymentType", _paymentType.PaymentType);
    (0, _defineProperty2.default)(_this, "ShippingCharge", ShippingCharge);
    (0, _defineProperty2.default)(_this, "PaymentRemain", PaymentRemain);
    (0, _defineProperty2.default)(_this, "OrderByTrans", OrderByTrans);
    (0, _defineProperty2.default)(_this, "OrderBy", OrderBy);
    (0, _defineProperty2.default)(_this, "date", []);
    (0, _defineProperty2.default)(_this, "dateRemind", []);
    return _this;
  }
  (0, _inherits2.default)(FilterOrder, _Vue);
  return (0, _createClass2.default)(FilterOrder, [{
    key: "watchFormDate",
    value: function watchFormDate(date) {
      this.form.from = date[0];
      this.form.to = date[1];
    }
  }, {
    key: "watchFormRemindDate",
    value: function watchFormRemindDate(date) {
      this.form.remindFrom = date[0];
      this.form.remindTo = date[1];
    }
  }, {
    key: "handleApply",
    value: function handleApply() {
      this.visible = false;
      this.$emit("apply", this.form);
    }
  }, {
    key: "handleClearAll",
    value: function handleClearAll() {
      this.form = {};
      this.date = [];
      this.handleApply();
    }
  }, {
    key: "fetchCustomers",
    value: function fetchCustomers() {
      var _this2 = this;
      _customer.customerApi.findAll().then(function (res) {
        return _this2.customers = res.data.customers;
      });
    }
  }, {
    key: "fetchStaffs",
    value: function fetchStaffs() {
      var _this3 = this;
      _staff.staffApi.findAll().then(function (res) {
        return _this3.staffs = res.data.data;
      });
    }
  }, {
    key: "fetchSaleChannel",
    value: function fetchSaleChannel() {
      var _this4 = this;
      _customerSource.customerSourceApi.findAll({}).then(function (res) {
        return _this4.saleChannels = res.data.customerSources;
      });
    }
  }, {
    key: "fetchCustomerGroup",
    value: function fetchCustomerGroup() {
      var _this5 = this;
      _customerGroup.customerGroupApi.findAll({}).then(function (res) {
        return _this5.customerGroups = res.data.customerGroups;
      });
    }
  }, {
    key: "fetchProduts",
    value: function fetchProduts() {
      var _this6 = this;
      _product.productApi.findAll({}).then(function (res) {
        return _this6.products = res.data.products;
      });
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchStaffs();
      this.fetchCustomers();
      this.fetchSaleChannel();
      this.fetchCustomerGroup();
      this.fetchProduts();
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      this.visible = true;
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("date", {
  deep: true
})], FilterOrder.prototype, "watchFormDate", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("dateRemind", {
  deep: true
})], FilterOrder.prototype, "watchFormRemindDate", null);
FilterOrder = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], FilterOrder);
var _default = exports.default = FilterOrder;
var OrderStatus;
(function (OrderStatus) {
  OrderStatus["Pending"] = "PENDING";
  OrderStatus["Processing"] = "PROCESSING";
  OrderStatus["Complete"] = "COMPLETE";
  OrderStatus["Cancel"] = "Cancel";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
var ShippingCharge;
(function (ShippingCharge) {
  ShippingCharge["Shiratori"] = "SHIRATORI";
  ShippingCharge["Customer"] = "CUSTOMER";
})(ShippingCharge || (exports.ShippingCharge = ShippingCharge = {}));
var PaymentRemain;
(function (PaymentRemain) {
  PaymentRemain["Paid"] = "PAID";
  PaymentRemain["Unpaid"] = "UNPAID";
})(PaymentRemain || (exports.PaymentRemain = PaymentRemain = {}));
var OrderBy;
(function (OrderBy) {
  OrderBy["CreatedAtDesc"] = "CREATED_AT_DESC";
  OrderBy["CreatedAtAsc"] = "CREATED_AT_ASC";
})(OrderBy || (exports.OrderBy = OrderBy = {}));
var OrderByTrans = exports.OrderByTrans = (0, _defineProperty2.default)((0, _defineProperty2.default)({}, OrderBy.CreatedAtDesc, "Created At Desc"), OrderBy.CreatedAtAsc, "Created At Asc");